import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../../services/api';
import '../../components/landing/landing.css';
import toast from 'react-hot-toast';

export default function ForgotPassword() {
  const [email, setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]     = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authApi.forgot({ email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not send reset link');
    } finally {
      setLoading(false);
    }
  };

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="cz-root">
      <div className="cz-grain" aria-hidden="true" />

      <div className="cz-auth">
        <aside className="cz-auth-side">
          <Link to="/" className="cz-wordmark">
            <span className="cz-wordmark-c">C</span>alibZa
            <sup className="cz-wordmark-tm">®</sup>
          </Link>

          <dl className="cz-auth-meta">
            <dt>Document</dt><dd>Auth-03 · Credential reset</dd>
            <dt>Issued</dt><dd>{today}</dd>
            <dt>Validity</dt><dd>Reset link expires in 30 minutes</dd>
          </dl>

          <h1 className="cz-auth-headline">
            Recalibrate your <em>access.</em>
          </h1>

          <p className="cz-auth-lede">
            Enter your work email and we&rsquo;ll send a one-time reset link.
            Sessions on other devices will be invalidated when you set the new
            password.
          </p>

          <div className="cz-auth-stamp">
            <div className="cz-auth-stamp-head">
              <span>Reset protocol</span>
              <strong>Verified</strong>
            </div>
            <div className="cz-auth-stamp-rows">
              <span className="k">Channel</span><span className="bar" /><span className="v">Signed email · DKIM</span>
              <span className="k">Token</span><span className="bar" /><span className="v">Single-use · 30 min</span>
              <span className="k">Audit</span><span className="bar" /><span className="v">Logged · IP + UA</span>
              <span className="k">Lockout</span><span className="bar" /><span className="v">5 attempts / hour</span>
            </div>
          </div>
        </aside>

        <main className="cz-auth-panel">
          <div className="cz-auth-record">
            <span>Serial № <strong>CZ-RESET-{today}</strong></span>
            <span>Rev. A · One-time</span>
          </div>

          <div className="cz-auth-panel-inner">
            {!sent ? (
              <>
                <header className="cz-auth-panel-head">
                  <span className="cz-mono-label">§ 01 · Identify</span>
                  <h2>Forgot your <em>password.</em></h2>
                  <p>Enter your work email. We&rsquo;ll mail a signed reset link.</p>
                </header>

                <form className="cz-auth-form" onSubmit={handleSubmit} autoComplete="on">
                  <div className="cz-field">
                    <label htmlFor="email" className="cz-field-label">
                      <span className="cz-field-label-num">01</span>
                      <span>Work email</span>
                    </label>
                    <input
                      id="email" type="email" required autoFocus
                      autoComplete="email"
                      className="cz-input"
                      placeholder="jane@acme.com"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                    />
                  </div>

                  <button type="submit" disabled={loading} className="cz-auth-submit">
                    {loading ? 'Issuing reset link…' : 'Send reset link'}
                    <span className="cz-btn-arrow">→</span>
                  </button>
                </form>
              </>
            ) : (
              <>
                <header className="cz-auth-panel-head">
                  <span className="cz-mono-label">§ 02 · Issued</span>
                  <h2>Check your <em>inbox.</em></h2>
                  <p>If an account exists for <strong style={{color:'var(--ink)'}}>{email}</strong>, a reset link is on its way. Look for sender <code style={{fontFamily:'var(--ff-mono)',fontSize:13}}>noreply@calibza.com</code>.</p>
                </header>

                <div style={{
                  padding: '18px 20px', background: 'var(--cream-warm)',
                  border: '1px solid var(--rule-soft)',
                  fontFamily: 'var(--ff-mono)', fontSize: 11,
                  color: 'var(--muted)', letterSpacing: '0.06em',
                  display: 'flex', flexDirection: 'column', gap: 6,
                }}>
                  <span><strong style={{color:'var(--ink)'}}>Tip ·</strong> The link expires in 30 minutes.</span>
                  <span><strong style={{color:'var(--ink)'}}>Not arrived?</strong> Check spam, then try again in 5 minutes.</span>
                </div>
              </>
            )}

            <div className="cz-auth-alt">
              <span>Remembered it?</span>
              <Link to="/login">Back to sign-in →</Link>
            </div>

            <p className="cz-auth-legal">
              For account-level help contact <a href="mailto:support@calibza.com">support@calibza.com</a> · <Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link>
            </p>
          </div>
        </main>
      </div>
    </div>
  );
}
